<template>
	<svg
		class="logo"
		xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink"
		width="75"
		height="100"
		viewBox="0 0 50.01 63.16"
	>
		<defs>
			<clipPath id="clip-path">
				<path d="M11.35,41.75l.73,1.47c-.23-.7-.53-1.35-.76-2a3.19,3.19,0,0,0,0,.57" fill="none" />
			</clipPath>
			<radialGradient
				id="radial-gradient"
				cx="-8.65"
				cy="65.33"
				r="1"
				gradientTransform="matrix(0.77, 0, 0, -0.77, 18.33, 92.36)"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0" stop-color="#e21013" />
				<stop offset="0.99" stop-color="#9a1915" />
				<stop offset="1" stop-color="#9a1915" />
			</radialGradient>
			<clipPath id="clip-path-2">
				<path d="M12.71,44.48l.73,1.43A2.31,2.31,0,0,0,12.71,44.48Z" fill="none" />
			</clipPath>
			<radialGradient
				id="radial-gradient-2"
				cx="-8.65"
				cy="65.33"
				r="1"
				gradientTransform="matrix(0.57, 0, 0, -0.57, 17.98, 82.29)"
				xlink:href="#radial-gradient"
			/>
			<clipPath id="clip-path-3">
				<path d="M44,8.75c.87-.54,1.19-1.89,1.57-2.83A14.27,14.27,0,0,0,44,8.75" fill="none" />
			</clipPath>
			<radialGradient
				id="radial-gradient-3"
				cx="-8.65"
				cy="65.33"
				r="1"
				gradientTransform="matrix(1.14, 0, 0, -1.14, 54.62, 82.02)"
				xlink:href="#radial-gradient"
			/>
			<clipPath id="clip-path-4">
				<polygon points="43.88 7.45 44.13 7.21 44.26 6.73 43.88 7.45" fill="none" />
			</clipPath>
			<radialGradient
				id="radial-gradient-4"
				cx="-8.65"
				cy="65.33"
				r="1"
				gradientTransform="matrix(0.29, 0, 0, -0.29, 46.58, 26.04)"
				xlink:href="#radial-gradient"
			/>
			<clipPath id="clip-path-5">
				<polygon points="35.12 30.83 34.38 32.63 35.35 30.57 35.12 30.83" fill="none" />
			</clipPath>
			<radialGradient
				id="radial-gradient-5"
				cx="-8.65"
				cy="65.34"
				r="1"
				gradientTransform="matrix(0.81, 0, 0, -0.81, 41.84, 84.3)"
				xlink:href="#radial-gradient"
			/>
			<clipPath id="clip-path-6">
				<polygon points="31.51 39.3 31.73 39.03 32.05 37.84 31.51 39.3" fill="none" />
			</clipPath>
			<radialGradient
				id="radial-gradient-6"
				cx="-8.65"
				cy="65.33"
				r="1"
				gradientTransform="matrix(0.55, 0, 0, -0.55, 36.55, 74.59)"
				xlink:href="#radial-gradient"
			/>
			<clipPath id="clip-path-7">
				<polygon points="36.29 28.18 36.11 28.78 36.52 27.93 36.29 28.18" fill="none" />
			</clipPath>
			<radialGradient
				id="radial-gradient-7"
				cx="-8.65"
				cy="65.33"
				r="1"
				gradientTransform="matrix(0.33, 0, 0, -0.33, 39.2, 50.17)"
				xlink:href="#radial-gradient"
			/>
			<clipPath id="clip-path-8">
				<polygon points="29.36 44.44 29.06 45.4 29.58 44.17 29.36 44.44" fill="none" />
			</clipPath>
			<radialGradient
				id="radial-gradient-8"
				cx="-8.65"
				cy="65.33"
				r="1"
				gradientTransform="matrix(0.47, 0, 0, -0.47, 33.41, 75.7)"
				xlink:href="#radial-gradient"
			/>
			<clipPath id="clip-path-9">
				<path
					d="M47.16,4.24l-.05-.05.05.05m-.55,0a.4.4,0,0,1,.49,0c-.16-.2,0-.5,0-.76C48,2.8,48.36,1.49,48.94.35q-1.19,1.94-2.33,3.89"
					fill="none"
				/>
			</clipPath>
			<radialGradient
				id="radial-gradient-9"
				cx="-8.65"
				cy="65.33"
				r="1"
				gradientTransform="matrix(1.61, 0, 0, -1.61, 61.66, 107.17)"
				xlink:href="#radial-gradient"
			/>
			<clipPath id="clip-path-10">
				<path
					d="M18.63,54.32h.47l1.24,2.4v.06l.56,2.78-1.19-2.49-.08-.17c-.56-.28-.27-2.07-.73-1.38a3.85,3.85,0,0,0-.27-1.18M21,56.46l-1.2-2.17H20l1,2.14.62,1.3Zm.3-2.21h.14l-.06.17-.08-.16M24,56.66a13.16,13.16,0,0,0,1.32-2.53h.4l-1.06,2.79-2.22,5.83-1.08-2.26,1-1.49-.08-.14.94-2.48.56-1.47-.49,1.5-.76,2.35Zm-5.46-2.54H19l.06.11h-.46l0-.12m1.15,0H20l.06.11h-.24l-.06-.11m1.52,0h.16l.05.11h-.16L21.22,54m4.19-.12h.39l0,.12h-.39l0-.12m.26-.67.11-.3.22.44-.11.29-.22-.44m-7.45.1.16-.44.15.29-.17.47-.14-.31m-.7-2.1.69,1.34-.15.4a5.6,5.6,0,0,1-.54-1.75m1.13.89.34-.93.05.1-.19.45.1.22-.16.44-.15-.28m.74-2,.05-.14.13.26-.06.16-.13-.27m.7-1.84.05-.15.1.2-.06.16-.1-.22m-4.23-2.14,0-1q1.46,2.89,3,5.76l-.35.92a48.72,48.72,0,0,1-2.63-5.72m1.26-1c.56,1.23,1.36,2.84,2.19,4.54l-.05.14q-1.08-2.33-2.14-4.67m4.39-.45,0-.09v0l0,.1v0M17.87,43.5q1.06,2.19,2.14,4.36L20,48q-1.05-2.25-2.09-4.5m2-2.48q.74,1.67,1.53,3.28l0,.09q-.77-1.68-1.49-3.37m3.42-.86a4.4,4.4,0,0,1-.85,2.22c-.17-.36.56-1.45.85-2.22M12,41.1c.09-.53-.35-.68-.59-.92.65-.23-.38-.54-.3-1.15.32-.35,1.59,1.5,1.29,2.34a.42.42,0,0,0-.4-.27m6.82-2.16a7.31,7.31,0,0,1,.49.85c-.16-.25-.33-.55-.49-.85m-1-2.27.25.38a6.46,6.46,0,0,0,.73,1.89,6,6,0,0,1-1-2.27m-4.68-11,0-.34q.92,2.4,1.91,4.78-1-2.21-1.9-4.44M5.39,21.86V21.5l.27.72Zm24.09,5.49c1.39-1.6,1.75-4.26,3.15-6C30.1,26.5,27.74,31.75,25.5,37c1.22-3.28,2.73-6.43,4-9.67M30.95,23a17.36,17.36,0,0,1,1.58-3.15c-.08,1-1.05,2.05-1.58,3.15-.1.25-.19.49-.28.76a3.49,3.49,0,0,1,.28-.76M6.89,17.5v-.28q.37,1.46.79,2.91-.42-1.31-.8-2.63m34.65-.56c-1.16,2.82-2.66,5.39-4,8.12a75.31,75.31,0,0,1,4-8.12M3.73,15.05a56,56,0,0,1,3.33,9.46c1,1.39,1,2.9,1.6,4.57l-.24-.4c.11,1.56,1.12,3.16,1.73,4.66.15,0,.08-.26.06-.47,1.59,3.69,3.39,7.27,4.93,10.91l-.85-1.63.16,1.18c-2.8-6-5.43-12.26-8-18.49q.68,1.52,1.4,3c-1.1-4.29-2.94-8.54-4.13-12.8m33.17-.43L36.3,16.3l-.19.21Zm-1.3.46.49-.51-.94,1.66ZM5,12.91c.47,1.27.66,2.55,1,3.82q-.35-1-.68-2.1l-.11.1q-.13-.91-.24-1.83M40.08,7.18l.25-.25q-1.75,3-3.41,6,1.54-2.91,3.16-5.79m1.09-.7a15.62,15.62,0,0,1-2.14,4c.62-1,1.44-2.66,2.14-4M6.9,13.84A63.89,63.89,0,0,1,5.67,6.55l.51-.48.33.74c.25,2.3.49,4.67.64,7.12ZM41.5,5.31l.15-.15-.19.68ZM8,3.53c.19-.11.16-.56.39-.65a35.16,35.16,0,0,0,.41,4.36,43.1,43.1,0,0,1,.45,4.38A53.36,53.36,0,0,1,8,3.53m38-.45C43.23,6.85,41.25,11.61,38.57,15c.64-1.62,1.82-3.26,1.95-4.9a.43.43,0,0,0-.2.34c-.2.35-.2.78-.6.6A12.82,12.82,0,0,1,40.8,8.56l-.17,0,.69-1.18c.17-.13.2,0,.19.16s-.07.36,0,0C42.21,6.12,41,6,42,4.81l-.43.2.06-.19c-.44.64-.74,1.71-1.35,2Q40.93,5.41,41.6,4c-3.22,4.89-5.82,10.37-8.68,15.16a35.83,35.83,0,0,1,3.24-6.44c0-1.5,1-1.8,1.43-2.92a.2.2,0,0,1-.19,0,1.3,1.3,0,0,1,.08-.37c-3,5.45-5.78,11-8.39,16.61l.15.62a6.64,6.64,0,0,1,1.4-2.77c-2.07,4.44-3.72,9.25-6,13.31l-.06-.09a5.46,5.46,0,0,1-1.25,3.1A30.68,30.68,0,0,1,26,33.94c.82-2,1.48-4.57,2.47-5.8-.17,0-.18-.21-.11-.48C26,33,23.77,38.29,21.66,43.64c-.73-1.54-1.45-3.08-2.15-4.63A169.14,169.14,0,0,1,11,18.13l.26-.26c.65.79.7,2.15,1.11,2.59a79,79,0,0,1-3.26-13c0-1-.62-2.79-.08-3l-.39-.55c0-.12.06-.39.21-.38L9,3.75c-.05-.58-.41-1.35-.19-2L8.06,2l.1-.48.05-.23.06-.26L8.18,1A3.63,3.63,0,0,1,8,1.59,1.67,1.67,0,0,1,7.7,2c0-.13-.08-.31-.13-.46a1.37,1.37,0,0,0-.09-.22.84.84,0,0,0-.13-.2c-.28.2-.55.35-.83.54V.84a3.43,3.43,0,0,1-.57,1c-.23.24-.49.3-.73-.13,0,.13-.12.4,0,.55-.49.17-.4,1.47-.95,1.15Q4.1,4,4,4.59l.58-.45A40.3,40.3,0,0,1,6,10.41c.36,2.1.66,4.22,1.08,6.19L6.78,16l0,1a8.62,8.62,0,0,1-.53-2c0,.63.45,1.43.18,1.91-1-3.1-1.39-6.42-2.3-9.66l-1-.68c-.45-.2-.65.16-.84.53s-.39.79-.85.47c.29,1.18,0,1.57-.43,2a1.78,1.78,0,0,0-.67,1.83A6.07,6.07,0,0,1,0,12c.06.35.13.69.22,1a21.13,21.13,0,0,0,1.55,3.49c1.16,2.57,1.72,5.35,2.72,8.14l1,2.87C8.18,33.77,11,40.12,14,46.06c-.18.18,0,.61,0,1h0q.9,1.77,1.77,3.59a3.63,3.63,0,0,1,0-.89c.7,1.27,1.37,2.59,2,3.92l-.19.51h.32L18,54l.07.14h.13l0,.12h0l0,0,0,.06h0l1.4,2.79L21,59.91l.17.86.15-.22,1.33,2.61L24.81,57q.5-1.43,1-2.86h.32L26,54H25.8l0-.12H26l-.09-.18.1-.31.25.49h.33l-.66-1.36A27,27,0,0,1,28.73,46l-.19.07a39.47,39.47,0,0,1,2.82-7.21,109.1,109.1,0,0,1,5.56-12.43c.5-.33,0-1.1.57-1.24a.85.85,0,0,1,0,.51c1.61-3.26,3.61-7,4.75-10.06C42,16,42,16.78,41.46,16.8L50,1.2c-3.65,6.23-7.21,12.32-10.56,18.56a200.8,200.8,0,0,0-9.22,19.32A5.44,5.44,0,0,1,29,41.55a166.14,166.14,0,0,1,6.77-15.72,8.65,8.65,0,0,0,1.16-3.12c0-.19.11-.34.25-.5a9.66,9.66,0,0,0,1.58-3.65l.77-.28c1.17-2.94,2.37-5.62,3.63-8.42-1.69,2.72-3,5.84-4.67,8.24a8.25,8.25,0,0,1,1.05-2.36,57.55,57.55,0,0,1,6.82-12.8l0,.1a2.6,2.6,0,0,0-.11.36,31.72,31.72,0,0,0,2-3.15c-.46.61-.8,1.61-1.42,1.89L48.06,0c-.68,1.07-1.67,1.86-2,3.08"
					fill="none"
				/>
			</clipPath>
			<radialGradient
				id="radial-gradient-10"
				cx="-8.65"
				cy="65.34"
				r="1"
				gradientTransform="matrix(28.48, 0, 0, -28.48, 271.26, 1892.44)"
				xlink:href="#radial-gradient"
			/>
			<clipPath id="clip-path-11"><path d="M13.43,45.91c.08.36.13.73.2,1.06L14,47Z" fill="none" /></clipPath>
			<radialGradient
				id="radial-gradient-11"
				cx="-8.65"
				cy="65.34"
				r="1"
				gradientTransform="matrix(0.44, 0, 0, -0.44, 17.52, 75.2)"
				xlink:href="#radial-gradient"
			/>
			<clipPath id="clip-path-12">
				<path d="M12.08,43.22a8,8,0,0,1,.29,1.09,1.1,1.1,0,0,1,.34.17Z" fill="none" />
			</clipPath>
			<radialGradient
				id="radial-gradient-12"
				cx="-8.65"
				cy="65.33"
				r="1"
				gradientTransform="matrix(0.5, 0, 0, -0.5, 16.68, 76.27)"
				xlink:href="#radial-gradient"
			/>
		</defs>
		<title>valor-svg</title>
		<g id="Layer_2" data-name="Layer 2">
			<g id="Layer_1-2" data-name="Layer 1">
				<g clip-path="url(#clip-path)">
					<rect x="11.31" y="41.19" width="0.77" height="2.03" fill="url(#radial-gradient)" />
				</g>
				<g clip-path="url(#clip-path-2)">
					<rect x="12.71" y="44.48" width="0.73" height="1.43" fill="url(#radial-gradient-2)" />
				</g>
				<g clip-path="url(#clip-path-3)">
					<rect x="43.95" y="5.93" width="1.57" height="2.83" fill="url(#radial-gradient-3)" />
				</g>
				<g clip-path="url(#clip-path-4)">
					<rect x="43.88" y="6.73" width="0.39" height="0.72" fill="url(#radial-gradient-4)" />
				</g>
				<g clip-path="url(#clip-path-5)">
					<rect x="34.38" y="30.57" width="0.97" height="2.06" fill="url(#radial-gradient-5)" />
				</g>
				<g clip-path="url(#clip-path-6)">
					<rect x="31.51" y="37.84" width="0.55" height="1.46" fill="url(#radial-gradient-6)" />
				</g>
				<g clip-path="url(#clip-path-7)">
					<rect x="36.11" y="27.93" width="0.41" height="0.85" fill="url(#radial-gradient-7)" />
				</g>
				<g clip-path="url(#clip-path-8)">
					<rect x="29.06" y="44.17" width="0.53" height="1.23" fill="url(#radial-gradient-8)" />
				</g>
				<g clip-path="url(#clip-path-9)">
					<rect x="46.61" y="0.35" width="2.33" height="3.9" fill="url(#radial-gradient-9)" />
				</g>
				<g clip-path="url(#clip-path-10)">
					<rect width="50.01" height="63.16" fill="url(#radial-gradient-10)" />
				</g>
				<g clip-path="url(#clip-path-11)">
					<rect x="13.43" y="45.91" width="0.56" height="1.11" fill="url(#radial-gradient-11)" />
				</g>
				<g clip-path="url(#clip-path-12)">
					<rect x="12.08" y="43.22" width="0.63" height="1.25" fill="url(#radial-gradient-12)" />
				</g>
			</g>
		</g>
	</svg>
</template>
